import React from "react";
import HomeCardProps from "@/model/interface/HomeCardProps";
import TransitionLink from "../TransitionLink";
import buysoonerLogo from "@/images/logo/buysooner.png";

const HomeCard = (props: HomeCardProps) => {
  return (
    <div className="group flex flex-col rounded-2xl border border-gray-200 bg-white shadow-sm overflow-hidden hover:shadow-lg transition-shadow">
      <TransitionLink to={props.ctaPath} className="overflow-hidden">
        <img
          src={props.image ? props.image : "images/placeholder.jpg"}
          alt={props.title}
          className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
        />
      </TransitionLink>
      <div className="flex flex-col grow p-5 gap-3">
        <div className="flex items-center gap-2">
          <img className="h-5 w-auto" src={buysoonerLogo} alt="BuySooner" />
          <TransitionLink
            to={props.ctaPath}
            className="font-semibold text-gray-700 hover:text-gray-900 transition-colors"
          >
            {props.title}
          </TransitionLink>
        </div>
        <p className="text-sm text-gray-600 leading-relaxed">{props.text}</p>
        <div className="mt-auto pt-3 text-center">
          <TransitionLink
            to={props.ctaPath}
            className="inline-flex items-center justify-center rounded-full bg-[#9BFBE0] px-6 py-2 text-sm font-medium text-[#010305] shadow-sm hover:shadow-md transition-all"
          >
            {props.ctaText}
          </TransitionLink>
        </div>
      </div>
    </div>
  );
};

HomeCard.propTypes = {};

export default HomeCard;
